<script lang="ts">
	import { hasReference, withSlugs } from '$lib/utils/storyblok/page';
	import FriendbuyScript from './friendbuyScript.svelte';
	import { afterNavigate } from '$app/navigation';
	import type { ISbStoryData } from '@storyblok/js';
	import { friendbuy } from '$lib/state/friendbuy.svelte';
	import { storyblok } from '$lib/state/storyblok.svelte';
	interface FriendbuyData {
		pages: string[];
		enabled: boolean;
	}

	let friendbuyData: ISbStoryData<FriendbuyData>['content'];

	afterNavigate(async ({ to }) => {
		if (!friendbuyData) {
			const response = await storyblok.client.getStory<FriendbuyData>('globals/friendbuy-config', {
				resolve_relations: 'pages'
			});
			friendbuyData = withSlugs(response).content;
		}

		friendbuy.show =
			to !== null &&
			friendbuyData.enabled &&
			to.url.searchParams.get('utm_source') === 'friendbuy' &&
			hasReference(friendbuyData.pages, to.url.pathname);
	});
</script>

{#if friendbuy.show}
	<FriendbuyScript />
{/if}
